// @ts-nocheck
import request from '../request';

export const getGenAIDescription = (data = {}) => {
  return request.post(`genai/description`, data).then((res) => res);
};

export const getTripDescription = (
  tripId = '',
  toneInstructions = '',
  existingContent = ''
) => {
  return request
    .post(`trips/${tripId}/aidescription`, {
      toneInstructions,
      existingContent
    })
    .then((res) => res);
};

export const getTripDayDescription = (
  tripDayId = '',
  toneInstructions = '',
  existingContent = ''
) => {
  return request
    .post(`trips/day/${tripDayId}/aidescription`, {
      toneInstructions,
      existingContent
    })
    .then((res) => res);
};

export const getTripDayFinalDescription = (
  tripDayId = '',
  toneInstructions = '',
  existingContent = '',
  currentDescription = ''
) => {
  return request
    .post(`trips/day/${tripDayId}/aifinaldescription`, {
      toneInstructions,
      existingContent,
      currentDescription
    })
    .then((res) => res);
};

export const getTripDetailedDayDescription = (tripDetailedDayId = '') => {
  return request
    .get(`trips/tripdetailedday/${tripDetailedDayId}/aidescription`)
    .then((res) => res);
};

export const getGenericAIDescription = (
  _tripId,
  instructions = '',
  existingContent = ''
) => {
  const question = existingContent
    ? `${instructions}\n\nExisting content:\n\n${existingContent}`
    : instructions;

  return request
    .post(`genai/description`, { instructions, question })
    .then((res) => res);
};
